import './Stepper.css';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import checkGreenIcon from './assets/step-check-green.svg';
import chevronHead from './assets/icon_chevron_head.svg';
import chevronMiddle from './assets/icon_chevron_middle.svg';
import chevronTail from './assets/icon_chevron_tail.svg';
import cx from 'classnames';
import homeIcon from './assets/icon-home.svg';
import { pure } from 'recompose';
import starBlueIcon from './assets/step-star-blue.svg';

const Stepper = ({ steps, homeLink, selectedStep, locale }) => (
  <ul className="progress-bar">
    <li className="steps home">
      <span className="step-container">
        <Link to={`/${locale}${homeLink}`}>
          <img alt="Home" src={homeIcon} />
        </Link>
      </span>
      {selectedStep !== 0 && (
        <span className="chevron-right">
          <img className="chevron" alt="" src={chevronMiddle} />
        </span>
      )}
    </li>
    {steps
      ? steps.map((step, index) => (
          <li
            key={step.name}
            className={cx({
              steps: true,
              current: index === selectedStep,
              past: index < selectedStep,
              future: index > selectedStep
            })}
          >
            <span className="chevron-left">
              {index === selectedStep && (
                <img className="chevron" alt="" src={chevronTail} />
              )}
            </span>
            <span className="step-container">
              <span className="number">
                {index > selectedStep && <span>{index + 1}</span>}
                {index === selectedStep && (
                  <span>
                    <img alt="" src={starBlueIcon} />
                  </span>
                )}
                {index < selectedStep && (
                  <span className="check-container">
                    <img alt="" src={checkGreenIcon} />
                  </span>
                )}
              </span>
              {index < selectedStep && (
                <Link className="step" to={`/${locale}${step.link}`}>
                  {step.name}
                </Link>
              )}
              {index >= selectedStep && (
                <span className="step">{step.name}</span>
              )}
            </span>
            {index + 1 !== selectedStep &&
              index + 1 !== steps.length && (
                <span className="chevron-right">
                  {index === selectedStep ? (
                    <img className="chevron" alt="" src={chevronHead} />
                  ) : (
                    <img className="chevron" alt="" src={chevronMiddle} />
                  )}
                </span>
              )}
          </li>
        ))
      : null}
  </ul>
);

Stepper.propTypes = {
  steps: PropTypes.array.isRequired,
  homeLink: PropTypes.string.isRequired,
  selectedStep: PropTypes.number,
  locale: PropTypes.string
};

Stepper.defaultProps = {
  selectedStep: 0,
  locale: 'en-Ca'
};

export default pure(Stepper);



// WEBPACK FOOTER //
// ./src/components/elements/Stepper/index.js